export default "__VITE_ASSET__CUfzkI8D__"